<template>
  <div>
    <span class="text-cloudygray"><slot name="leftSide" /></span>
    <span class="text-darksilver px-4">></span>
    <span class="text-info"><slot name="rightSide" /></span>
  </div>
</template>
